import Feature5 from './Feature5'
export default Feature5
